import keycloak from '@/lib/keycloak'

const DEFAULT_MIN_VALIDITY_SECONDS = 30

let refreshPromise: Promise<string | undefined> | null = null

export async function ensureFreshKeycloakToken(minValiditySeconds = DEFAULT_MIN_VALIDITY_SECONDS): Promise<string | undefined> {
  if (!keycloak.token || !keycloak.refreshToken) {
    return keycloak.token
  }

  if (!keycloak.isTokenExpired(minValiditySeconds)) {
    return keycloak.token
  }

  return refreshKeycloakToken(minValiditySeconds)
}

export async function refreshKeycloakToken(minValiditySeconds = -1): Promise<string | undefined> {
  if (!keycloak.refreshToken) {
    return keycloak.token
  }

  if (!refreshPromise) {
    refreshPromise = keycloak.updateToken(minValiditySeconds).then(() => keycloak.token).finally(() => {
      refreshPromise = null
    })
  }

  return refreshPromise
}
